import { createAction, props } from '@ngrx/store';

import { Board } from '@bsuccess/models/brainstorming/board.model';
import { Card } from '@bsuccess/models/brainstorming/card.model';
import { List } from '@bsuccess/models/brainstorming/list.model';
import { SessionTaskModel } from '@bsuccess/models/session/session-task.model';
import { SessionCategoryModel } from '@bsuccess/models/session/session-category';
import { Activity } from '@bsuccess/models/activities/activity.model';
import { BoardModel } from '@bsuccess/models/board/board.model';
import { UserModel } from '@bsuccess/models/user.model';

export const loadBoards = createAction('[Workshop][Brainstorming Page] Load Boards');

export const loadBoardsSuccess = createAction(
    '[Workshop][Brainstorming API] Load Boards Success',
    props<{
        response: any;
    }>()
);

export const loadBoardsFailure = createAction(
    '[Workshop][Brainstorming API] Load Boards Failure',
    props<{ error: string }>()
);

export const clearBoard = createAction(
    '[Workshop][Board Page] Clear Board',
);

export const loadBoard = createAction(
    '[Workshop][Board Page] Load Board',
    props<{ boardId: string }>()
);

export const loadBoardSuccess = createAction(
    '[Workshop][Board API] Load Board Success',
    props<{
        board: Board;
    }>()
);

export const loadBoardFailure = createAction(
    '[Workshop][Board API] Load Board Failure',
    props<{ error: string }>()
);

export const loadImportBoard = createAction(
    '[Workshop][Board Page] Load Import Board',
    props<{ boardId: string }>()
);

export const loadImportBoardSuccess = createAction(
    '[Workshop][Board API] Load Import Board Success',
    props<{
        board: BoardModel;
    }>()
);

export const loadImportBoardFailure = createAction(
    '[Workshop][Board API] Load Import Board Failure',
    props<{ error: string }>()
);

export const addBoard = createAction('[Workshop][Board Page] Add Board');

export const addBoardSuccess = createAction(
    '[Workshop][Board API] Add Board Success',
    props<{ board: Board }>()
);

export const addBoardFailure = createAction(
    '[Workshop][Board API] Add Board Failure',
    props<{ error: string }>()
);

export const saveBoard = createAction('[Workshop][Board Page] Save Board');

export const saveBoardSuccess = createAction('[Workshop][Board API] Save Board Success');

export const saveBoardFailure = createAction(
    '[Workshop][Board API] Save Board Failure',
    props<{ error: string }>()
);


export const renameBoard = createAction(
    '[Workshop][Board Page] Rename Board',
    props<{ newName: string }>()
);

// ADD CARD
export const addCard = createAction(
    '[Workshop][Board Page] Add Card',
    props<{ listId: string; card: Card }>()
);

export const addCardSuccess = createAction(
    '[Workshop][Board API] Add Card Success',
    props<{ listId: string; card: Card }>()
);

export const addCardFailure = createAction(
    '[Workshop][Board API] Add Card Failure',
    props<{ error: string }>()
);

export const addCardViaSocket = createAction(
    '[Workshop][Board API] Add Card Via Socket',
    props<{ listId: string; card: Card }>()
);

// COPY CARD
export const copyCard = createAction(
    '[Workshop][Board Page] Copy Card',
    props<{ id: string }>()
);

export const copyCardSuccess = createAction(
    '[Workshop][Board API] Copy Card Success',
    props<{ id: string }>()
);

export const copyCardFailure = createAction(
    '[Workshop][Board API] Copy Card Failure',
    props<{ error: string }>()
);

// REMOVE CARD
export const removeCard = createAction(
    '[Workshop][Board Page] Remove Card',
    props<{ cardId: string; listId: string }>()
);

export const removeCardSuccess = createAction(
    '[Workshop][Board API] Remove Card Success',
    props<{ cardId: string; listId: string }>()
);

export const removeCardFailure = createAction(
    '[Workshop][Board API] Remove Card Failure',
    props<{ error: string }>()
);

export const socketRemoveCard = createAction(
    '[Workshop][Board API] Remove Card Via Socket',
    props<{ cardId: string; listId: string }>()
);
// MOVE CARD
export const moveCard = createAction(
    '[Workshop][Board Page] Move Card',
    props<{ move: { listId: string; cardId: string; dropIndex: number }; lists: List[] }>()
);

export const moveCardSuccess = createAction(
    '[Workshop][Board API] Move Card Success',
    props<{ move: { listId: string; cardId: string; dropIndex: number }; lists: List[] }>()
);

export const moveCardFailure = createAction(
    '[Workshop][Board API] Move Card Failure',
    props<{ error: string }>()
);

export const socketMoveCard = createAction(
    '[Workshop][Board API] Move Card Via Socket',
    props<{ move: { listId: string; cardId: string; dropIndex: number }; lists: List[] }>()
);

// ADD LIST
export const addList = createAction(
    '[Workshop][Board Page] Add List',
    props<{ list: List }>()
);

export const addListSuccess = createAction(
    '[Workshop][Board API] Add List Success',
    props<{ list: List }>()
);

export const addListFailure = createAction(
    '[Workshop][Board API] Add List Failure',
    props<{ error: string }>()
);

export const socketAddList = createAction(
    '[Workshop][Board API] Add List Via Socket',
    props<{ list: List }>()
);

// REMOVE LIST
export const removeList = createAction(
    '[Workshop][Board Page] Remove List',
    props<{ listId: string }>()
);

export const removeListSuccess = createAction(
    '[Workshop][Board API] Remove List Success',
    props<{ listId: string }>()
);

export const removeListFailure = createAction(
    '[Workshop][Board API] Remove List Failure',
    props<{ error: string }>()
);

export const socketRemoveList = createAction(
    '[Workshop][Board API] Remove List Via Socket',
    props<{ listId: string }>()
);

// MOVE LIST
export const moveList = createAction(
    '[Workshop][Board Page] Move List',
    props<{ lists: List[]; move: { listId: string; dropIndex: number }; }>()
);

export const moveListSuccess = createAction(
    '[Workshop][Board API] Move List Success',
    props<{ lists: List[]; move: { listId: string; dropIndex: number }; }>()
);

export const moveListFailure = createAction(
    '[Workshop][Board API] Move List Failure',
    props<{ error: string }>()
);

export const socketMoveList = createAction(
    '[Workshop][Board API] Move List Via Socket',
    props<{ lists: List[]; move: { listId: string; dropIndex: number }; }>()
);

// RENAME LIST
export const listNameChange = createAction(
    '[Workshop][Board Page] List Name change',
    props<{ listId: string; name: string }>()
);

export const listNameChangeSuccess = createAction(
    '[Workshop][Board Page] List Name change Success',
    props<{ listId: string; name: string }>()
);

export const listNameChangeFailure = createAction(
    '[Workshop][Board API] List Name change Failure',
    props<{ error: string }>()
);

export const listSubtitleChange = createAction(
    '[Workshop][Board API] List Subtitle change',
    props<{ listId: string; description: string }>()
);

export const listSubtitleChangeSuccess = createAction(
    '[Workshop][Board API] List Subtitle change Success',
    props<{ listId: string; description: string }>()
);

export const listSubtitleChangeFailure = createAction(
    '[Workshop][Board API] List Subtitle change Failure',
    props<{ error: string }>()
);

export const listSubtitleRemove = createAction(
    '[Workshop][Board API] List Subtitle Remove',
    props<{ listId: string;}>()
);

export const listSubtitleRemoveSuccess = createAction(
    '[Workshop][Board API] List Subtitle Remove Success',
    props<{ listId: string; }>()
);

export const listSubtitleRemoveFailure = createAction(
    '[Workshop][Board API] List Subtitle Remove Failure',
    props<{ error: string }>()
);


export const socketListNameChange = createAction(
    '[Workshop][Board Page] List Name change Via Socket',
    props<{ listId: string; name: string }>()
);

// CARD COLOR CHANGE
export const cardColorChange = createAction(
    '[Workshop][Board API] Card Color Change',
    props<{ cardId: string; color: string, typeCard: string }>()
);

export const cardsColorChange = createAction(
    '[Workshop][Board API] Card Color Change',
    props<{ cardsId: string ; color: string, typeCard: string }>()
);

export const cardColorChangeSuccess = createAction(
    '[Workshop][Board API] Card Color Change Success',
    props<{ cardId: string; color: string, typeCard: string }>()
);

export const cardColorChangeFailure = createAction(
    '[Workshop][Board API] Card Color Change Failure',
    props<{ error: string }>()
);

export const socketCardColorChange = createAction(
    '[Workshop][Board API] Card Color Change Via Socket',
    props<{ cardId: string; color: string, typeCard: string }>()
);

// CARD NAME CHANGE
export const cardNameChange = createAction(
    '[Workshop][Board Page] Card name change',
    props<{ cardId: string; name: string }>()
);

export const cardNameChangeSuccess = createAction(
    '[Workshop][Board API] Card name change Success',
    props<{ cardId: string; name: string }>()
);

export const cardNameChangeFailure = createAction(
    '[Workshop][Board API] Card name change Failure',
    props<{ error: string }>()
);

export const socketCardNameChange = createAction(
    '[Workshop][Board Page] Card name change Via Socket',
    props<{ cardId: string; name: string }>()
);

// CARD DATE CHANGE
export const updateCardDate = createAction(
    '[Workshop][Board Page] Card date change',
    props<{ cardId: string, due: string }>()
);

export const updateCardDateSuccess = createAction(
    '[Workshop][Board API] Card date Success',
    props<{ cardId: string, due: string }>()
);

export const updateCardDateFailure = createAction(
    '[Workshop][Board API] Card date Failure',
    props<{ error: string }>()
);

export const socketUpdateCardDate = createAction(
    '[Workshop][Board API] Card Date Via Socket',
    props<{ cardId: string, due: string }>()
);

// CARD DESCRIPTION
export const updateCardDescription = createAction(
    '[Workshop][Board Page] Update Card Description',
    props<{ cardId: string, description: string }>()
);

export const updateCardDescriptionSuccess = createAction(
    '[Workshop][Board API] Update Card Description Success',
    props<{ cardId: string, description: string }>()
);

export const updateCardDescriptionFailure = createAction(
    '[Workshop][Board API] Update Card Description Failure',
    props<{ error: string }>()
);

export const socketUpdateCardDescription = createAction(
    '[Workshop][Board API] Update Card Description Via Socket',
    props<{ cardId: string, description: string }>()
);

// CARD Note
export const updateCardNote = createAction(
    '[Workshop][Board Page] Update Card Note',
    props<{ cardId: string, note: number }>()
);

export const updateCardNoteSuccess = createAction(
    '[Workshop][Board API] Update Card Note Success'
);

export const updateCardNoteFailure = createAction(
    '[Workshop][Board API] Update Card Note Failure',
    props<{ error: string }>()
);

// OTHER ACTIONS
export const addChecklist = createAction(
    '[Workshop][Board Card Dialog] Add Checklist',
    props<{
        boardId: string,
        cardId: string,
        checklist: {
            id: string,
            name: string,
            checkItemsChecked: number,
            checkItems: {
                id: string,
                name: string,
                checked: boolean
            }[]
        }
    }>()
);

export const addChecklistSuccess = createAction(
    '[Workshop][Board API] Add Checklist Success',
    props<{
        cardId: string,
        checklist: {
            id: string,
            name: string,
            checkItemsChecked: number,
            checkItems: {
                id: string,
                name: string,
                checked: boolean
            }[]
        }
    }>()
);

export const addChecklistFailure = createAction(
    '[Workshop][Board API] Add Checklist Failure',
    props<{ error: string }>()
);

export const socketAddChecklist = createAction(
    '[Workshop][Board API] Add Checklist Via Socket',
    props<{
        cardId: string,
        checklist: {
            id: string,
            name: string,
            checkItemsChecked: number,
            checkItems: {
                id: string,
                name: string,
                checked: boolean
            }[]
        }
    }>()
);

export const addcheckItem = createAction(
    '[Workshop][Board Card Dialog] Add Check Item Form',
    props<{
        boardId: string,
        checkItemForm: {
            cardId: string,
            checklistId: string,
            id: string,
            name: string,
            checked: boolean
        }
    }>()
);

export const addcheckItemSuccess = createAction(
    '[Workshop][Board API] Add Check Item Form Success',
    props<{
        checkItemForm: {
            cardId: string,
            checklistId: string,
            id: string,
            name: string,
            checked: boolean
        }
    }>()
);

export const addcheckItemFailure = createAction(
    '[Workshop][Board API] Add Check Item Form Failure',
    props<{ error: string }>()
);

export const socketAddcheckItem = createAction(
    '[Workshop][Board API] Add Check Item Form Via Socket',
    props<{
        checkItemForm: {
            cardId: string,
            checklistId: string,
            id: string,
            name: string,
            checked: boolean
        }
    }>()
);

export const removeCheckList = createAction(
    '[Workshop][Board Card Dialog] Remove Check List',
    props<{
        boardId: string,
        checkListForm: {
            cardId: string,
            checklistId: string
        }
    }>()
);

export const removeCheckListSuccess = createAction(
    '[Workshop][Board API] Remove Check List Success',
    props<{
        checkListForm: {
            cardId: string,
            checklistId: string
        }
    }>()
);

export const removeCheckListFailure = createAction(
    '[Workshop][Board API] Remove Check List Failure',
    props<{ error: string }>()
);

export const socketRemoveCheckList = createAction(
    '[Workshop][Board API] Remove Check List Via Socket',
    props<{
        checkListForm: {
            cardId: string,
            checklistId: string
        }
    }>()
);

export const removeCheckItem = createAction(
    '[Workshop][Board Card Dialog] Remove Check Item',
    props<{
        boardId: string,
        checkListForm: {
            cardId: string,
            checklistId: string,
            checkItemId: string
        }
    }>()
);

export const removeCheckItemSuccess = createAction(
    '[Workshop][Board API] Remove Check Item Success',
    props<{
        checkListForm: {
            cardId: string,
            checklistId: string,
            checkItemId: string
        }
    }>()
);

export const removeCheckItemFailure = createAction(
    '[Workshop][Board API] Remove Check Item Failure',
    props<{ error: string }>()
);

export const socketRemoveCheckItem = createAction(
    '[Workshop][Board API] Remove Check Item Via Socket',
    props<{
        checkListForm: {
            cardId: string,
            checklistId: string,
            checkItemId: string
        }
    }>()
);

export const updateCheckItem = createAction(
    '[Workshop][Board Card Dialog] Update Check Item',
    props<{
        boardId: string,
        checkItemForm: {
            cardId: string,
            checklistId: string,
            checkItemId: string,
            name: string,
            checked: boolean
        }
    }>()
);

export const updateCheckItemSuccess = createAction(
    '[Workshop][Board API] Update Check Item Success',
    props<{
        checkItemForm: {
            cardId: string,
            checklistId: string,
            checkItemId: string,
            name: string,
            checked: boolean
        }
    }>()
);

export const updateCheckItemFailure = createAction(
    '[Workshop][Board API] Update Check Item Failure',
    props<{ error: string }>()
);

export const socketUpdateCheckItem = createAction(
    '[Workshop][Board API] Update Check Item Via Socket',
    props<{
        checkItemForm: {
            cardId: string,
            checklistId: string,
            checkItemId: string,
            name: string,
            checked: boolean
        }
    }>()
);

// export const addLabel = createAction(
//     '[Workshop][Board Card Dialog] Add Label',
//     props<{ label: { id: string, name: string, color: string } }>()
// );

export const updateLbels = createAction(
    '[Workshop][Board Card Dialog] Update Labels',
);

export const updateLbelsSuccess = createAction(
    '[Workshop][Board API] Update Labels Success',
    props<{
        labels: { id: string, name: string, color: string }[]
    }>()
);

export const updateLbelsFailure = createAction(
    '[Workshop][Board API] Update Labels Failure',
    props<{ error: string }>()
);

export const addLabel = createAction(
    '[Workshop][Board Card Dialog] Add Label',
    props<{
        name: string,
        color: string
    }>()
);

export const addLabelSuccess = createAction(
    '[Workshop][Board API] Add Label Success',
    props<{
        name: string,
        color: string,
        id: string,
    }>()
);

export const addLabelFailure = createAction(
    '[Workshop][Board API] Add Label Failure',
    props<{ error: string }>()
);

export const socketAddLabel = createAction(
    '[Workshop][Board API] Add Label Via Socket',
    props<{
        name: string,
        color: string,
        id: string,
    }>()
);

export const updateLabel = createAction(
    '[Workshop][Board Card Dialog] Update Label',
    props<{
        id: string,
        name: string,
        color: string
    }>()
);

export const updateLabelSuccess = createAction(
    '[Workshop][Board API] Update Label Success',
    props<{
        name: string,
        color: string,
        id: string,
    }>()
);

export const updateLabelFailure = createAction(
    '[Workshop][Board API] Update Label Failure',
    props<{ error: string }>()
);

export const socketUpdateLabel = createAction(
    '[Workshop][Board API] Update Label Via Socket',
    props<{
        name: string,
        color: string,
        id: string,
    }>()
);

export const toggleLabel = createAction(
    '[Workshop][Board Card Dialog] Toggle Label',
    props<{
        boardId: string,
        toggleForm: {
            cardId: string,
            labelId: string
        }
    }>()
);

export const toggleLabelSuccess = createAction(
    '[Workshop][Board API] Toggle Label Success',
    props<{
        toggleForm: {
            cardId: string,
            labelId: string
        }
    }>()
);

export const toggleLabelFailure = createAction(
    '[Workshop][Board API] Toggle Label Failure',
    props<{ error: string }>()
);

export const socketToggleLabel = createAction(
    '[Workshop][Board API] Toggle Label Via Socket',
    props<{
        toggleForm: {
            cardId: string,
            labelId: string
        }
    }>()
);


export const duplicateCard = createAction(
    '[Workshop][Board Card Dialog] Duplicate Card',
    props<{
        duplicate: {
            cardId: string,
            listId: string
        }
    }>()
);

export const duplicateCardSuccess = createAction(
    '[Workshop][Board API] Duplicate Card Success',
    props<{
        duplicate: {
            cardId: string,
            listId: string
        },
        card: Card
    }>()
);

export const duplicateCardFailure = createAction(
    '[Workshop][Board API] Duplicate Card Failure',
    props<{ error: string }>()
);

export const socketDuplicateCard = createAction(
    '[Workshop][Board API] Duplicate Card Via Socket',
    props<{
        duplicate: {
            cardId: string,
            listId: string
        },
        card: Card
    }>()
);

export const addCardComment = createAction(
    '[Workshop][Board Card Dialog] Add Card Comment',
    props<{
        cardId: string,
        comment: {
            idMember: string
            message: any,
            time: Date
        }
    }>()
);

export const addCardCommentSuccess = createAction(
    '[Workshop][Board API] Add Card Comment Success',
    props<{
        cardId: string, comment: {
            id: string,
            idMember: string
            message: any,
            time: Date
        }
    }>()
);

export const addCardCommentFailure = createAction(
    '[Workshop][Board API] Add Card Comment Failure',
    props<{ error: string }>()
);

export const socketAddCardComment = createAction(
    '[Workshop][Board API] Add Card Comment Via Socket',
    props<{
        cardId: string, comment: {
            id: string,
            idMember: string
            message: any,
            time: Date
        }
    }>()
);


export const deleteComment = createAction(
    '[Workshop][Board Card Dialog] Delete Card Comment',
    props<{
        cardId: string;
        commentId: string;
    }>()
);

export const deleteCommentSuccess = createAction(
    '[Workshop][Board API] Delete Card Comment Success',
    props<{
        id: string;
        cardId: string;
        commentId: string;
    }>()
);

export const deleteCommentFailure = createAction(
    '[Workshop][Board API] Delete Card Comment Failure',
    props<{ error: string }>()
);

export const socketDeleteComment = createAction(
    '[Workshop][Board API] Delete Card Comment Via Socket',
    props<{
        id: string;
        cardId: string;
        commentId: string;
    }>()
);

// --- OTHER ACTIONS

export const addNewLabel = createAction(
    '[Workshop][Board Page] Add new label',
    props<{ newLabel: any }>()
);

export const addActionPlan = createAction('[Workshop][Board Page] Add Action Plan');

export const addActionPlanConfirmed = createAction(
    '[Workshop][Board Page] Add Action Plan Confirmed',
    props<{ actionPlan: SessionTaskModel }>()
);

export const addActionPlanCancelled = createAction(
    '[Workshop][Board Page] Add Action Plan Cancelled'
);

export const addActionPlanSuccess = createAction(
    '[Workshop][Board API] Add Action Plan Success',
    props<{ actionPlan: SessionTaskModel }>()
);

export const addActionPlanSuccessViaSocket = createAction(
    '[Workshop][Board API] Add Action Plan Success Via Socket',
    props<{ actionPlan: SessionTaskModel }>()
);

export const addActionPlanFailure = createAction(
    '[Workshop][Board API] Add Action Plan Failure',
    props<{ error: string }>()
);

export const sortCardsBySum = createAction('[Workshop][Board Page] Sort Cards By Sum');

export const showFilterDialog = createAction('[Workshop][Board Page] Show Filter Dialog');

export const filterAllCards = createAction(
    '[Workshop][Board Filter Dialog] Filter All Cards'
);

export const filterCardsbyIdLists = createAction(
    '[Workshop][Board Filter Dialog] Filter Cards By Id Lists',
    props<{ idLists: string[] }>()
);

export const filterCardsbyIdCategories = createAction(
    '[Workshop][Board Filter Dialog] Filter Cards By Id Categories',
    props<{ idCategories: string[] }>()
);

export const filterCardsbyIdTags = createAction(
    '[Workshop][Board Filter Dialog] Filter Cards By Id Tags',
    props<{ idTags: string[] }>()
);

export const filterCardsbyScore = createAction(
    '[Workshop][Board Filter Dialog] Filter Cards By Score',
    props<{ score: number; operator: string }>()
);

export const filterCardsbyId = createAction(
    '[Workshop][Board Filter Dialog] Filter Cards By Id',
    props<{ idCards: string[] }>()
);

export const showCardsToColumnsDialog = createAction(
    '[Workshop][Board Page] Show Cards To Columns Dialog'
);

export const showCardsToActionPlansDialog = createAction(
    '[Workshop][Board Page] Show Cards To Action plans Dialog'
);

export const showExportCardsDialog = createAction(
    '[Workshop][Board Page] Show Export Cards Dialog'
);

export const showImportCardsDialog = createAction(
    '[Workshop][Board Page] Show Import Cards Dialog'
);

// find Actions

export const cardToColumnsbyIdCards = createAction(
    '[Workshop][Board Cards to Columns Dialog] Cards By Card Id',
    props<{ idCards: string[] }>()
);

export const cardToColumnsbyIdLists = createAction(
    '[Workshop][Board Cards to Columns Dialog] Cards By List Id',
    props<{ idLists: string[] }>()
);

export const cardToColumnsbyIdCategories = createAction(
    '[Workshop][Board Cards to Columns Dialog] Cards By Category Id',
    props<{ idCategories: string[] }>()
);

export const cardToColumnsbyScore = createAction(
    '[Workshop][Board Cards to Columns Dialog] Cards By Score',
    props<{ score: number; operator: string }>()
);

export const saveCardsToColumns = createAction(
    '[Workshop][Board Cards to Columns Dialog] Save Cards to Columns',
    props<{ boardId: string, activity: Activity }>()
);

export const saveCardsToColumnsSuccess = createAction(
    '[Workshop][Board Cards to Columns Dialog] Save Cards to Columns Success',
    props<{ boardId: string, activity: Activity, lists: any[] }>()
);

export const saveCardsToColumnsViaSocket = createAction(
    '[Workshop][Board Cards to Columns Dialog] Save Cards to Columns Via Socket',
    props<{ boardId: string, activity: Activity, lists: any[] }>()
);

export const saveCardsToColumnsFailure = createAction(
    '[Workshop][Brainstorming API] Save Cards to Columns Failure',
    props<{ error: string }>()
);

// Export Actions

export const exportAllCards = createAction(
    '[Workshop][Board Export Cards Dialog] Export All Cards'
);

export const exportCardsbyIdLists = createAction(
    '[Workshop][Board Export Cards Dialog] Export Cards By Id Lists',
    props<{ idLists: string[] }>()
);

export const exportCardsbyIdCategories = createAction(
    '[Workshop][Board Export Cards Dialog] Export Cards By Id Categories',
    props<{ idCategories: string[] }>()
);

export const exportCardsbyScore = createAction(
    '[Workshop][Board Export Cards Dialog] Export Cards By Score',
    props<{ score: number; operator: string }>()
);

export const exportCardsbyId = createAction(
    '[Workshop][Board Export Cards Dialog] Export Cards By Id',
    props<{ idCards: string[] }>()
);

// Import Actions

export const importAllCards = createAction(
    '[Workshop][Board Export Cards Dialog] Import All Cards'
);

export const importCardsbyIdLists = createAction(
    '[Workshop][Board Export Cards Dialog] Import Cards By Id Lists',
    props<{ idLists: string[] }>()
);

export const importCardsbyId = createAction(
    '[Workshop][Board Export Cards Dialog] Import Cards By Id',
    props<{ idCards: string[] }>()
);


// cards to actionplan

export const allCardsToActionplans = createAction(
    '[Workshop][Cards To Actionplans] All Cards To Actionplans'
);

export const cardsToActionplanByIdLists = createAction(
    '[Workshop][Cards To Actionplans] Cards To Actionplans By Id Lists',
    props<{ idLists: string[] }>()
);

export const cardsToActionplanByIdLabels = createAction(
    '[Workshop][Cards To Actionplans] Cards To Actionplans By Id Labels',
    props<{ idLabels: string[] }>()
);

export const cardsToActionplanByScore = createAction(
    '[Workshop][Cards To Actionplans] Cards To Actionplans By Score',
    props<{ score: number; operator: string }>()
);

export const cardsToActionplanById = createAction(
    '[Workshop][Cards To Actionplans] Cards To Actionplans By Id',
    props<{ idCards: string[] }>()
);

export const cardsToActionplanSuccess = createAction(
    '[Workshop][Brainstorming Api] Cards To Actionplans Success',
    props<{ tasks: SessionTaskModel[] }>()
);

export const cardsToActionplanFailure = createAction(
    '[Workshop][Brainstorming Api] Cards To Actionplans Failure',
    props<{ error: string }>()
);
export const saveExportCards = createAction(
    '[Workshop][Brainstorming API] Save Export Cards',
    props<{ boardId: string; listId: string; boardType: string }>()
);

export const saveExportCardsSuccess = createAction(
    '[Workshop][Brainstorming API] Save Export Cards Success'
);

export const saveExportCardsFailure = createAction(
    '[Workshop][Brainstorming API] Save Export Cards Failure',
    props<{ error: string }>()
);

export const downloadPNG = createAction(
    '[Workshop][Brainstorming Page] Download Board PNG'
);

export const downloadSVG = createAction(
    '[Workshop][Brainstorming Page] Download Board SVG'
);

export const showCardResultDialog = createAction(
    '[Workshop][Board Page] Show Card Result Dialog',
    props<{ card: Card }>()
);

export const showStartBrainstormDialog = createAction(
    '[Workshop][Board Page] Show Start Brainstorm Dialog'
);

export const addCardCategory = createAction(
    '[Workshop][Board Page] Add Card Category',
    props<{ category: SessionCategoryModel }>()
);

export const updateCardCategory = createAction(
    '[Workshop][Board Page] Update Card Category',
    props<{ category: SessionCategoryModel }>()
);

export const updateCardCategoryColor = createAction(
    '[Workshop][Board Page] Update Card Category Color',
    props<{ category: SessionCategoryModel }>()
);

export const updateCategories = createAction(
    '[Workshop][Board Page] Update Categories',
);

export const updateCategoriesSuccess = createAction(
    '[Workshop][Board Page] Update Categories Success'
);

export const updateCategoriesFailure = createAction(
    '[Workshop][Board Page] Update Categories Failure',
    props<{ error: any }>()
);

export const updateAllCategoriesChecked = createAction(
    '[Workshop][Board Page] Update All Categories Checkbox',
    props<{ checked: boolean }>()
);

export const deleteCategory = createAction(
    '[Workshop][Board Page] Delete Category',
    props<{ category: SessionCategoryModel }>()
);

export const importCardsToBoard = createAction(
    '[Workshop][Board Page] Import Cards To Board',
    props<{ listId: string, cardsId: string[] }>()
);

export const importCardsToBoardSuccess = createAction(
    '[Workshop][Board API] Import Cards To Board Success',
    props<{ response: any, listId: string }>()
);

export const importCardsToBoardViaSocket = createAction(
    '[Workshop][Board API] Import Cards To Board Via Socket',
    props<{ response: any, listId: string }>()
);

export const importCardsToBoardFailure = createAction(
    '[Workshop][Board API] Import Cards To Board Failure',
    props<{ error: string }>()
);

export const saveCardsRates = createAction('[Workshop][Board Page] Save Cards Rates',
    props<{ cards: Card[], user: UserModel }>());

export const saveCardsRatesSuccess = createAction('[Workshop][Board Page] Save Cards Rates Success',
    props<{ lists: any, cards: any }>());

export const saveCardsRatesFailure = createAction(
    '[Workshop][Board Page] Save Cards Rates Failure',
    props<{ error: string }>()
);

export const showSendVotesDialog = createAction(
    '[Workshop][Board Page] Show Send Votes Dialog'
);

export const refreshBoard = createAction(
    '[Workshop][Brainstorming Page] Refresh Board'
);

export const toggleShowAllCards = createAction(
    '[Workshop][Brainstorming Page] Toggle Show All cards',
    props<{ enabled: boolean }>()
);

export const toggleShowAllCardsSuccess = createAction(
    '[Workshop][Brainstorming Page] Toggle Show All cards Success',
    props<{ enabled: boolean }>()
);

export const toggleShowAllCardsFailure = createAction(
    '[Workshop][Brainstorming Page] Toggle Show All cards Failure',
    props<{ error: any }>()
);

export const toggleShowAllCardsViaSocket = createAction(
    '[Workshop][Brainstorming Page] Toggle Show All cards Via Socket',
    props<{
        enabled: boolean
    }>()
);

export const toggleShowMembersName = createAction(
    '[Workshop][Brainstorming Page] Toggle Show Members Names',
    props<{
        enabled: boolean
    }>()
);

export const toggleShowMembersNameSuccess = createAction(
    '[Workshop][Brainstorming Page] Toggle Show Members Names Success',
    props<{
        enabled: boolean
    }>()
);

export const toggleShowMembersNameFailure = createAction(
    '[Workshop][Brainstorming Page] Toggle Show Members Names Failure',
    props<{
        error: any
    }>()
);

export const toggleShowMembersNameViaSocket = createAction(
    '[Workshop][Brainstorming Page] Toggle Show Members Names Via Socket',
    props<{
        enabled: boolean
    }>()
);

export const removeLabel = createAction(
    '[Workshop][Brainstorming API] Remove Label',
    props<{
        labelId: string, label: any
    }>()
);

export const removeLabelSuccess = createAction(
    '[Workshop][Brainstorming API] Remove Label Success',
    props<{
        labelId: string
    }>()
);

export const socketRemoveLabel = createAction(
    '[Workshop][Brainstorming API] Remove Label Via Socket',
    props<{
        labelId: string
    }>()
);

export const removeLabelFailure = createAction(
    '[Workshop][Brainstorming API] Remove Label Failure',
    props<{ error: string }>()
);


export const cardRating = createAction(
    '[Workshop][Brainstorming API] Card Rating',
    props<{
        cardId: string;
        user: UserModel;
        rate: number;
    }>()
);

export const cardRatingSuccess = createAction(
    '[Workshop][Brainstorming API] Card Rating Success',
    props<{
        cardId: string;
        user: UserModel;
        rate: number;
    }>()
);

export const socketcardRating = createAction(
    '[Workshop][Brainstorming API] Card Rating Via Socket',
    props<{
        cardId: string;
        user: UserModel;
        rate: number;
    }>()
);

export const cardRatingFailure = createAction(
    '[Workshop][Brainstorming API] Card Rating Failure',
    props<{ error: string }>()
);

export const updateTimer = createAction(
    '[Workshop][Brainstorming API] Update Timer',
    props<{
        timer: {
            timer: boolean,
            categories: SessionCategoryModel[],
            balance: number,
            maxPerCard: number,
            timerType: string
        }
    }>()
);

export const updateTimerSuccess = createAction(
    '[Workshop][Brainstorming API] Update Timer Success',
    props<{
        timer: {
            timer: boolean,
            categories: SessionCategoryModel[],
            balance: number,
            maxPerCard: number,
            timerType: string
        }
    }>()
);

export const socketUpdateTimer = createAction(
    '[Workshop][Brainstorming API] Update Timer Via Socket',
    props<{
        timer: {
            timer: boolean,
            categories: SessionCategoryModel[],
            balance: number,
            maxPerCard: number,
            timerType: string
        }
    }>()
);

export const updateTimerFailure = createAction(
    '[Workshop][Brainstorming API] Update Timer Failure',
    props<{ error: string }>()
);

export const substractUserPoints = createAction(
    '[Workshop][Brainstorming] Substract User Points',
    props<{ sumRates: number }>()
);

export const sort = createAction(
    '[Workshop][Brainstorming API] Sort Board',
);

export const sortSuccess = createAction(
    '[Workshop][Brainstorming API] Sort Board Success',
    props<{
        lists: any[];
    }>()
);

export const socketSort = createAction(
    '[Workshop][Brainstorming API] Sort Board Via Socket',
    props<{
        lists: any[];
    }>()
);

export const sortFailure = createAction(
    '[Workshop][Brainstorming API] Sort Board Failure',
    props<{ error: string }>()
);

export const updateWorkFlowStep = createAction(
    '[Workshop][Brainstorming API] Update WorkFlow Step',
    props<{ step: number }>()
);

export const updateWorkFlowStepSuccess = createAction(
    '[Workshop][Brainstorming API] Update WorkFlow Step Success',
    props<{
        step: number
    }>()
);

export const socketUpdateWorkFlowStep = createAction(
    '[Workshop][Brainstorming API] Update WorkFlow Step Via Socket',
    props<{
        step: number
    }>()
);

export const updateWorkFlowStepFailure = createAction(
    '[Workshop][Brainstorming API] Update WorkFlow Step Failure',
    props<{ error: string }>()
);

export const showSettingsDialog = createAction('[Workshop][Brainstorming] Show Settings Dialog');

export const updateDisplayLabel = createAction(
    '[Workshop][Brainstorming API] Update Display Label via Settings',
    props<{
        label: boolean
    }>()
);

export const updateDisplayLabelSuccess = createAction(
    '[Workshop][Brainstorming API] Update Display Label via Settings Success',
    props<{
        label: boolean
    }>()
);

export const updateDisplayLabelFailure = createAction(
    '[Workshop][Brainstorming API] Update Display Label via Settings Failure',
    props<{
        error: any
    }>()
);

export const updateDisplayLabelViaSocket = createAction(
    '[Workshop][Brainstorming API] Update Display Label Via Settings Via Socket',
    props<{
        label: boolean
    }>()
);